import { ComponentConfiguration } from './component_configuration';

export class SceneProviderConfiguration extends ComponentConfiguration {}
